/**
 * 普通键值对对象
 * @param data 对象
 * @returns formData
 */
export const objectToFormData = (data: Record<string, any>) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });
  return formData;
};

/**
 *
 * @param referer
 * @param ignoreEngines 需要排除的搜索引擎，默认是空
 */
export const isFromSearchEngineByReferer = (referer: string | undefined, ignoreEngines?: string[] | string) => {
  if (!referer) return false;
  let searchEngines = ['.google.', 'bing.com', '.yahoo.', 'duckduckgo.com', 'yandex.', 'naver.com', 'ya.ru', '.brave.com', 'coccoc.com'];
  let copyIgnoreEngines: string[] = [];
  if (ignoreEngines) {
    if (typeof ignoreEngines === 'string') {
      copyIgnoreEngines = ignoreEngines.split(',');
    }
    if (Array.isArray(ignoreEngines)) {
      copyIgnoreEngines = ignoreEngines;
    }
  }
  searchEngines = searchEngines.filter(item => !copyIgnoreEngines.includes(item));
  return searchEngines.some(item => referer.includes(item));
};
